import React, {useState} from "react";
import {Box} from "@mui/material";
import ChannelSetup from "../../marketing/meta/ChannelSetup";
import AccountSetup from "./AccountSetup";
import {PlatformType} from "crqlar-react-common/dist/models/newsletter/platformType";
import {NewsletterAccount} from "crqlar-react-common/dist/models/newsletter/newsletterAccount";
import {useTranslation} from "react-i18next";
import {MAILEON_LANGS} from "crqlar-react-common/dist/utils/translations.util";

interface Props {
    navigateDirectlyToAdAccount: boolean
}

const AdAccountSetup = (props: Props) => {
    const {t} = useTranslation()
    const platformOptions: PlatformType[] = [
        {value: 'FACEBOOK_INSTAGRAM_ADS', label: t('Facebook / Instagram Ads')},
        // { value: 'GOOGLE_ADS', label: t('Google Ads') },
    ];

    const [newsletterAccount, setNewsletterAccount] = useState({locale: MAILEON_LANGS[0].code} as NewsletterAccount);
    const [platformType, setPlatformType] = React.useState(platformOptions[0].value);

    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        setActiveStep(1);
    };

    const handleBack = () => {
        setActiveStep(0);
    };

    const handlePlatformChange = (newValue: string) => {
        setPlatformType(newValue);
    };

    return (
        <Box sx={{width: '100%', typography: 'body1'}}>
            <Box sx={{p: 3}}>
                {(activeStep === 0 && !props.navigateDirectlyToAdAccount) &&
                    <ChannelSetup
                        handleNext={handleNext}
                        activeStep={0}
                        platformType={platformType}
                        handlePlatformChange={(newValue) => handlePlatformChange(newValue as string)}
                        platformOptions={platformOptions}
                    />
                }
                {/*When user logs out - it should navigate him directly to this second tab*/}
                {(activeStep === 1 || props.navigateDirectlyToAdAccount) &&
                    <AccountSetup
                        handleBack={handleBack}
                        activeStep={1}
                    />
                }
            </Box>
        </Box>
    )
}

export default AdAccountSetup
